import { getPrice } from './getPrice';

/**
 * @memberof module:util
 * @function
 * @name getLCLChargeableWeight
 * @description Calculate LCL Chargeable Weight.
 * If weight unit is in LB or LBS, then convert it to KG.
 * If volume unit is in CFT, then convert it to CBM.
 *
 * @param {Object} obj - It contains weight and volume info.
 * @param {Object} obj.totalWeight - total weight of the shipment.
 * @param {Object} obj.weightUnit - unit of total weight.
 * @param {Object} obj.totalVolume - total volume of the shipment.
 * @param {Object} obj.volumeUnit - unit of total volume.
 * @returns {number}
 *
 * @example
 * console.log(getLCLChargeableWeight({ totalWeight:1405, weightUnit:"LBS", totalVolume:6, volumeUnit:"CFT" })); //211.89
 */
export const getLCLChargeableWeight = ({
  totalWeight,
  weightUnit,
  totalVolume,
  volumeUnit,
}) => {
  let wtInKG;
  let volInCBM;
  if (weightUnit === 'KG') {
    wtInKG = totalWeight;
  } else {
    //it's LB not LBS in Form Left Tab Shipping mode
    //  but it's LBS in Search mode
    wtInKG = totalWeight / 2.205;
  }

  if (volumeUnit === 'CBM') {
    volInCBM = totalVolume;
  } else {
    volInCBM = totalVolume / 35.315;
  }

  const temp = getPrice(Math.max(wtInKG / 1000, volInCBM));

  return temp;
};
